import Select from 'react-select';
import { SelectCompProps } from '../../Interfaces/Props';

const SelectComp = (props: SelectCompProps) => {
  return (
    <Select
      {...props.field}
      id={props.id}
      placeholder={props.placeholder}
      isDisabled={props.isDisabled}
      isLoading={props.isLoading}
      isClearable={props.isClearable}
      isSearchable={props.isSearchable}
      isMulti={props.isMulti}
      menuPosition={props.menuPosition}
      className={props.className}
      value={props.value}
      defaultValue={props.defaultValue}
      onBlur={props.onBlur!}
      onChange={props.onChange}
      options={props.options}
      closeMenuOnSelect={props.closeMenuOnSelect}
      noOptionsMessage={props.noOptionsMessage}
      styles={{
        menuList: (provided) => ({
          ...provided,
          maxHeight: 200,
          overflowY: 'auto',
        }),
      }}
    />
  );
};

export default SelectComp;
